import React from 'react';

type VinoProps = {
    foto: string;
    nome: string;
    descrizione: string;
    link: string;
    colore: string;
    testo: string;
    vendita: string;
};

const Vino: React.FC<VinoProps> = ({ foto, nome, descrizione, link, colore, testo, vendita }) => {

    const bg_img: React.CSSProperties = {
        background: colore,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '17.025rem',
        height: '17.025rem',

    };

    const titolo_vino: React.CSSProperties = {
        color: testo,
        borderColor: colore,
    };

    const fotoVino = {
        //DA UTILIZZARE
        //backgroundImage: `url("${foto}")`,

        //PROVA
        //backgroundImage: `url(${foto})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        maxWidth: '15.4rem',
        flexBasis: '40%',
        display: 'flex',
        height: '19.3545rem',
        marginBottom: '3.2rem',
        objectFit: 'contain' as any,
    }

    return (
        <div
            className="flex flex-col lg:flex-row lg:gap-24 mx-6 h-auto lg:h-fit"
            style={{
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {/* Sezione Immagine */}
            <div className="flex flex-col items-center lg:w-[17.025rem] w-full lg:h-full">
                <div className="relative" style={bg_img}>
                    <img
                        className="object-cover w-full h-full"
                        style={fotoVino}
                        src={foto}
                        alt={nome}
                    />
                </div>
            </div>

            {/* Sezione Titolo e Descrizione */}
            <div
                className="flex flex-col items-center lg:items-start w-full lg:w-1/2 text-center lg:text-left mt-4 lg:mt-0">
                <h1
                    className="border-b-[3px] pb-2 w-full text-3xl lg:text-5xl font-semibold mb-4 items-center justify-center"
                    style={titolo_vino}
                >
                    {nome}
                </h1>
                <p className="text-base lg:text-xl px-4 lg:px-0 text-left">{descrizione}</p>
                <p className="text-s text-center lg:text-lg px-4 lg:px-0 md:text-right w-full text-gray-500 italic"> {vendita} </p>
            </div>
        </div>
    );
};

export default Vino;
